var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"no-bullet-list"},_vm._l((_vm.value),function(contact){return _c('li',{key:contact,staticClass:"p-2"},[_vm._v(" "+_vm._s(contact)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }